import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { rootState } from '../../../redux/store';
import { NotAllowed } from './NotAllowed';

interface IProtectedUsersProps {
    children?: React.ReactNode;
    protectedUsers: string[];
    showWarningMessage?: boolean;
}

export const ProtectedUsers: React.FC<IProtectedUsersProps> = ({ children, protectedUsers = [] , showWarningMessage = false}) => {
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);

    const username = userAndTokenData?.user.username;
    // console.log(username, protectedUsers, username && protectedUsers.includes(username));

    return (
    <>
        {
            userAndTokenData && protectedUsers.includes(userAndTokenData?.user.username)
            ?
            children
            :
            showWarningMessage && <NotAllowed/>
        }
    </>)
};
